/**
 * 桌面客户端推广引导工具
 * 控制弹窗 / 顶栏 banner 的展示时机和持久化
 */

/** localStorage key：用户手动关闭过弹窗 */
export const LS_DOWNLOAD_CLIENT_DISMISSED = 'downloadClientShowed_v2'

/** sessionStorage key：本次 tab 已展示过，换页后再展示 */
export const SS_HOLD_PROMO_UNTIL_ROUTE_CHANGE =
  'downloadClientPromo_holdUntilRouteChange'

/** localStorage key：下载记录页触发的弹窗待展示标记 */
const LS_PENDING_PROMO = 'downloadClientPromo_pending'

/**
 * 判断是否应展示桌面客户端推广弹窗
 */
export function shouldShowClientPromo(): boolean {
  // 用户已手动关闭 → 不再展示
  if (localStorage.getItem(LS_DOWNLOAD_CLIENT_DISMISSED) === 'true') {
    return false
  }
  // 本次 tab 正处于「等待换页后再展示」状态
  if (sessionStorage.getItem(SS_HOLD_PROMO_UNTIL_ROUTE_CHANGE) === 'true') {
    return false
  }
  return true
}

/**
 * 标记「需要在下次换页后展示推广弹窗」
 * 用于下载记录页点击下载后，不立即弹窗，等用户回到照片页再弹
 */
export const markClientPromoPending = setClientPromoPending

export function setClientPromoPending(): void {
  localStorage.setItem(LS_PENDING_PROMO, 'true')
  sessionStorage.setItem(SS_HOLD_PROMO_UNTIL_ROUTE_CHANGE, 'true')
}

/**
 * 清除待展示标记
 */
export function clearClientPromoPending(): void {
  localStorage.removeItem(LS_PENDING_PROMO)
}

/**
 * 是否有待展示的推广（用于顶栏 banner 判断）
 */
export function hasClientPromoPending(): boolean {
  return localStorage.getItem(LS_PENDING_PROMO) === 'true'
}
